module.exports = __webpack_public_path__ + "static/img/wechat_code1.a259de3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/wechat_code1.jpg
// module id = ehNc
// module chunks = 13